/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'captcha': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M963.801 218.17a72.85 72.85 0 00-57.513-63.903 1357.96 1357.96 0 01-185.961-42.816 690.802 690.802 0 01-166.15-97.134 76.046 76.046 0 00-88.827 0 435.825 435.825 0 01-167.428 96.495 624.342 624.342 0 01-180.849 44.733A67.738 67.738 0 0060.2 219.449s-1.917 160.399-1.917 301.627c0 255.616 301.627 502.924 452.44 502.924s406.43-174.458 447.328-499.09c10.224-191.712 3.195-306.1 3.195-306.1zM799.568 415.635L484.52 712.788a42.816 42.816 0 01-52.401 5.112l-8.307-7.03-173.82-180.848a42.816 42.816 0 0163.905-58.791l143.145 150.174 283.733-268.397a42.816 42.816 0 1158.792 63.904"/>'
  }
})
